module.exports = __webpack_public_path__ + "img/stena13.bdf12780.jpg";